import { Application } from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo";
import "./sentry_integration";
import "./cable";
import "lazysizes";
import bsCustomFileInput from "bs-custom-file-input";

import PortfolioEditorController from "./controllers/portfolio_editor_controller";
import TiltContractCardController from "./controllers/tilt_contract_card_controller";
import ChatValidationController from "./controllers/chat_validation_controller";
import MyDropzoneController from "./controllers/my_dropzone_controller";
import AvatarUploaderController from "./controllers/avatar_uploader_controller";
import ProfessionalChooserController from "./controllers/professional_chooser_controller";
import InitialProjectDataController from "./controllers/initial_project_data_controller";
import ProjectCreationController from "./controllers/project_creation_controller";
import ProfessionalSearchController from "./controllers/professional_search_controller";
import LineItemsController from "./controllers/line_items_controller";
import BestInPlaceController from "./controllers/best_in_place_controller";
import UserSettingsController from "./controllers/users/user_settings_controller";
import TabNavigationController from "./controllers/users/tab_navigation_controller";
import CountryCitySelectorController from "./controllers/vendor_sign_ups/country_city_selector_controller";
import FormValidationController from "./controllers/form_validation_controller";
import MyCarouselController from "./controllers/my_carousel_controller";
import ShareController from "./controllers/share_controller";
import ChatController from "./controllers/chat_controller";
import AttachmentPreviewController from "./controllers/attachment-preview-controller";
import ApplyVoucherController from "./controllers/apply_voucher_controller";
import MarketingNotificationController from "./controllers/marketing_notification_controller";

const application = Application.start();

// Configure Stimulus development experience
// application.debug = false;
application.debug = true;
window.Stimulus = application;
window.bsCustomFileInput = bsCustomFileInput;

// Turbo configuration
Turbo.session.drive = false;
Turbo.session.cache = true;

application.register("portfolio-editor", PortfolioEditorController);
application.register("tilt-contract-card", TiltContractCardController);
application.register("chat-validation", ChatValidationController);
application.register("my-dropzone", MyDropzoneController);
application.register("avatar-uploader", AvatarUploaderController);
application.register("professional-chooser", ProfessionalChooserController);
application.register("initial-project-data", InitialProjectDataController);
application.register("project-creation", ProjectCreationController);
application.register("professional-search", ProfessionalSearchController);
application.register("line-items", LineItemsController);
application.register("best-in-place", BestInPlaceController);
application.register("user-settings", UserSettingsController);
application.register("tab-navigation", TabNavigationController);
application.register("country-city-selector", CountryCitySelectorController);
application.register("form_validation", FormValidationController);
application.register("my-carousel", MyCarouselController);
application.register("share", ShareController);
application.register("chat", ChatController);
application.register("attachment-preview", AttachmentPreviewController);
application.register("apply-voucher", ApplyVoucherController);
application.register("marketing-notification", MarketingNotificationController);

export { application, Turbo };
